<template>
  <div class="ui-progress" role="progressbar" :aria-valuenow="value" aria-valuemin="0" aria-valuemax="100" :data-tone="tone ?? undefined">
    <div class="ui-progress__bar" :style="{ width: `${value}%` }"></div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    value: number;
    tone?: "travel" | "work" | "combat" | "econ" | "social" | "warning" | null;
  }>(),
  {
    value: 0,
    tone: null
  }
);
</script>

<style scoped>
.ui-progress {
  width: 100%;
  height: 8px;
  border-radius: var(--radius-pill);
  background: var(--progress-track-bg);
  border: 1px solid var(--progress-track-border);
  overflow: hidden;
}

.ui-progress__bar {
  height: 100%;
  background: linear-gradient(
    90deg,
    color-mix(in srgb, var(--accent) 85%, white),
    color-mix(in srgb, var(--accent) 30%, transparent)
  );
  border-radius: var(--radius-pill);
  transition: width var(--dur-2) var(--ease-out);
}

.ui-progress[data-tone="travel"] {
  --accent: var(--accent-travel);
}

.ui-progress[data-tone="work"] {
  --accent: var(--accent-work);
}

.ui-progress[data-tone="combat"] {
  --accent: var(--accent-combat);
}

.ui-progress[data-tone="econ"] {
  --accent: var(--accent-econ);
}

.ui-progress[data-tone="social"] {
  --accent: var(--accent-social);
}

.ui-progress[data-tone="warning"] {
  --accent: var(--color-warning);
}
</style>
